import { render, staticRenderFns } from "./LoadingPopupWithAsyncFallback.vue?vue&type=template&id=20ae781e&scoped=true"
import script from "./LoadingPopupWithAsyncFallback.vue?vue&type=script&lang=js"
export * from "./LoadingPopupWithAsyncFallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae781e",
  null
  
)

export default component.exports